import React, { useState } from 'react';
import { Button, Flex, Text } from 'core/components';
import { FiEye, FiEyeOff } from 'react-icons/fi';

/**
 * Component for displaying sensitive text (like API keys) with show/hide toggle
 */
const HiddenText = ({ text, maskChar = '•', showToggleButton = true, initiallyVisible = false, ...textProps }) => {
  const [isVisible, setIsVisible] = useState(initiallyVisible);

  if (!text) {
    return <Text {...textProps}>{text}</Text>;
  }

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const maskedText = maskChar.repeat(Math.min(text.length, 24)); // Limit mask length for very long strings

  return (
    <Flex alignItems="center">
      <Text {...textProps} mr={showToggleButton ? 2 : 0}>
        {isVisible ? text : maskedText}
      </Text>
      {showToggleButton && (
        <Button
          icon={isVisible ? FiEyeOff : FiEye}
          onClick={toggleVisibility}
          minimal
          small
          title={isVisible ? 'Hide text' : 'Show text'}
        />
      )}
    </Flex>
  );
};

export default HiddenText;
